import { render, staticRenderFns } from "./GeneralReportsList.vue?vue&type=template&id=255c3012&scoped=true&"
import script from "./GeneralReportsList.vue?vue&type=script&lang=js&"
export * from "./GeneralReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255c3012",
  null
  
)

export default component.exports